import useFeatureAccess from "./useFeatureAccess";

/**
 * Lo que las pantallas necesitan saber del plan del team, sacado de
 * `GET /plans/team/:teamID/access` (useFeatureAccess). Ya no pide `/plans/team/:id`:
 * ese contrato queda para el comparador e Igor, y el front hace un solo request.
 *
 * Solo bloquea lo que el api marca `blockedBy: 'plan'`, que existe unicamente con el
 * enforcement prendido. Cargando, con error o con una key desconocida no se bloquea
 * nada: el enforcement real es server-side y el front no puede conceder nada; fallar
 * cerrado le mostraria "Disponible en Premium" a quien paga Premium.
 */
export default function usePlan() {
  const { loading, failed, ready, enforced, agendaCap, access } = useFeatureAccess();

  const isBlocked = (key) => ready && access(key).blockedBy === "plan";

  return {
    // null = no configurado; { value: null } = configurado sin tope. No es lo mismo.
    agendaCap,
    isLoading: loading,
    isError: failed,
    settled: ready,
    // Condicion de todo bloqueo, incluidos los LIMITES que se comparan afuera.
    enforced,
    isBlocked,
    allows: (key) => !isBlocked(key),
    // 'read_only' en una feature degradable. Sin dato => null (no degradar nada).
    restrictionOf: (key) => (enforced ? access(key).restriction : null),
  };
}
